import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6accbe0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right-content" }
const _hoisted_2 = {
  key: 0,
  class: "right-tips"
}
const _hoisted_3 = { class: "right-count" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { ref, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { IRightSortConfig, IRightConfig } from '@common/core/interface/IModel';
import { useGlobalState } from '../../../store/carOwnerRight';
import { baseMixins } from '@common/mixins/baseMixins';
import rightReceivedZHCN from '@/assets/images/carOwnerRight/rightReceived_zh-CN.png';
import rightReceivedZHHK from '@/assets/images/carOwnerRight/rightReceived_zh-HK.png';
import rightReceivedENGB from '@/assets/images/carOwnerRight/rightReceived_en-GB.png';

export default /*#__PURE__*/_defineComponent({
  __name: 'RightItem',
  props: {
    detail: null,
    action: { default: 'none' },
    beforeJump: null,
    type: null,
    counts: null,
    sort: null
  },
  setup(__props: any) {

const props = __props as { detail: IRightConfig, action: 'link' | 'none', beforeJump?: () => boolean, type?: 'choose', counts?: number, sort?: IRightSortConfig }



const { isEng, getLanguage } = baseMixins();
const lang = getLanguage();
const { getT } = i18n;
const $t = getT();
const state = useGlobalState();
const router = useRouter();
const route = useRoute();
const { brand } = route.query;

// 获取权益累计已领取数量
const curReceiveCount = ref(0);
// 获取当月权益累计已领取数量
const curMonthReceiveCount = ref(0);
// n选1组获取权益累计已领取数量
const curChooseReceiveCount = ref(0);
// n选1组获取权益累计已领取数量
const curChooserMonthReceiveCount = ref(0);

watch(
  () => state.value.allActivityNosRecord,
  () => {
    props.detail.activity.forEach((activityNo) => {
      curReceiveCount.value += state.value.allActivityNosRecord[activityNo] || 0;
    });
    if (props.type === 'choose') {
      props.sort?.chooseRights.forEach((right) => {
        right.activity.forEach((activityNo) => {
          curChooseReceiveCount.value += state.value.allActivityNosRecord[activityNo] || 0;
        });
      });
    }
  },
);

watch(
  () => state.value.MonthActivityNosRecord,
  () => {
    props.detail.activity.forEach((activityNo) => {
      curMonthReceiveCount.value += state.value.MonthActivityNosRecord[activityNo] || 0;
    });
    if (props.type === 'choose') {
      props.sort?.chooseRights.forEach((right) => {
        right.activity.forEach((activityNo) => {
          curChooserMonthReceiveCount.value += state.value.MonthActivityNosRecord[activityNo] || 0;
        });
      });
    }
  },
);

const rightState = computed(() => {
  if (props.type === 'choose' && curChooseReceiveCount.value >= Number(props.sort?.chooseReceiveCount)) {
    return {
      info: $t('已领取，{counts}份', { counts: curReceiveCount.value }),
      state: 'received',
    };
  }
  if (props.type === 'choose' && curChooserMonthReceiveCount.value >= Number(props.sort?.chooseReceiveMonthCount)) {
    return {
      info: $t('{counts}份（当月已领取）', { counts: props.detail.detailInfoReceiveCount }),
      state: 'disabled',
    };
  }
  if (curReceiveCount.value >= Number(props.detail.detailInfoReceiveCount)) {
    return {
      info: $t('已领取，{counts}份', { counts: props.detail.detailInfoReceiveCount }),
      state: 'received',
    };
  }
  if (curMonthReceiveCount.value >= Number(props.detail.detailInfoReceiveMonthCount)) {
    // 当月领取完了 要展示总领取次数（当月已领取）
    return {
      info: $t('{counts}份（当月已领取）', { counts: props.detail.detailInfoReceiveCount }),
      state: 'disabled',
    };
  }
  return {
    info: props.detail.homeInfo,
  };
});

const isDisabled = computed(() => rightState.value.state === 'disabled');
const isReceived = computed(() => rightState.value.state === 'received');

// n选1组达到累计领取上限只展示已领取的奖品
const isHide = computed(() => {
  if (
    props.type === 'choose' &&
    curChooseReceiveCount.value >= Number(props.sort?.chooseReceiveCount) &&
    !curReceiveCount.value
  ) {
    return true;
  }
  return false;
});

const goRightDetailPage = (flag = false) => {
  if (props.action === 'none' || flag) {
    return;
  }
  if (props.beforeJump) {
    const flag = props.beforeJump();
    if (!flag) {
      return;
    }
  }
  reportStatistics({
    evtName: `${brand}rightItemBtnClick`,
    desc: '专享权益页面权益列表按钮点击',
  });
  state.value.detail = props.detail;
  router.push({
    path: '/rightDetail',
    query: {
      ...route.query,
      key: props.detail.key
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (!_unref(isHide))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["right", { eng: _unref(isEng), disabled: _unref(isDisabled) || _unref(isReceived) }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goRightDetailPage(_unref(isDisabled) || _unref(isReceived))))
      }, [
        _createElementVNode("p", _hoisted_1, [
          _createTextVNode(_toDisplayString(__props.detail.homeName), 1),
          (__props.type === 'choose')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref($t)('({counts}选1)', { counts: __props.counts })), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(rightState).info), 1),
        (_unref(isReceived))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "right-state",
              src: _unref(lang) === 'zh-CN' ? _unref(rightReceivedZHCN) : _unref(lang) === 'zh-HK' ? _unref(rightReceivedZHHK) : _unref(rightReceivedENGB),
              alt: ""
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          class: "right-label",
          src: _unref(isDisabled) || _unref(isReceived) ? __props.detail.homeIconDisabled : __props.detail.homeIcon
        }, null, 8, _hoisted_5)
      ], 2))
    : _createCommentVNode("", true)
}
}

})